import './Footer.css';
import { Link } from 'react-router-dom';

const CookiesPage = () => {
  return (
    <div id='FooterMainDiv'>
        <p className='FooterLink'>Polska Akademia Tyczki 2026</p>
        <Link to='/Polityka' className='FooterLink'>Polityka prywatności</Link>
    </div>
  )
};

export default CookiesPage;
